import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export type SoundManifestEntry = {
  id: string;
  filename: string;
  source: string;
  license: string;
  attribution: string;
  proof_url: string;
  allowed_redistribution: boolean;
};

export type SoundManifest = {
  updated_at: string;
  entries: SoundManifestEntry[];
};

@Injectable({ providedIn: 'root' })
export class SoundManifestService {
  constructor(private http: HttpClient) {}

  loadManifest(): Observable<SoundManifest> {
    return this.http.get<SoundManifest>('assets/sounds/manifest.json');
  }
}
